var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_1747)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14_1747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00003 0C6.44691 0 6.00003 0.446875 6.00003 1V1.55938C3.73441 1.91875 2.00003 3.88125 2.00003 6.25V7.29375C2.00003 8.7125 1.51566 10.0906 0.631284 11.1969L0.165659 11.7812C-0.0155914 12.0063 -0.0499664 12.3156 0.0750336 12.575C0.200034 12.8344 0.462534 13 0.750034 13H13.25C13.5375 13 13.8 12.8344 13.925 12.575C14.05 12.3156 14.0157 12.0063 13.8344 11.7812L13.3688 11.2C12.4844 10.0906 12 8.7125 12 7.29375V6.25C12 3.88125 10.2657 1.91875 8.00003 1.55938V1C8.00003 0.446875 7.55316 0 7.00003 0ZM7.00003 3H7.25003C9.04378 3 10.5 4.45625 10.5 6.25V7.29375C10.5 8.79062 10.9344 10.25 11.7407 11.5H2.25941C3.06566 10.25 3.50003 8.79062 3.50003 7.29375V6.25C3.50003 4.45625 4.95628 3 6.75003 3H7.00003ZM9.00003 14H7.00003H5.00003C5.00003 14.5312 5.20941 15.0406 5.58441 15.4156C5.95941 15.7906 6.46878 16 7.00003 16C7.53128 16 8.04066 15.7906 8.41566 15.4156C8.79066 15.0406 9.00003 14.5312 9.00003 14Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_1747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14_1747"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V16H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLAlertIcon);
export default __webpack_public_path__ + "static/media/l_alert_icon.c3525d996589eb32ae84586048d27397.svg";
export { ForwardRef as ReactComponent };